import { NbDialogService, NbToastrService, NbDialogRef } from '@nebular/theme';
import { PagingService } from '../../../../shared/Services/PagingService';
import { FormMAsterService } from '../../services/formMaster.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { CreateFormComponent } from '../create/create.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formsmaster-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetFormMasterFieldsComponent extends BaseComponent implements OnInit {
  fields: any;
  formId: number;
  constructor(
    public route: Router,
    public service: FormMAsterService,
    public paging: PagingService,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private aRoute: ActivatedRoute,
    // private diagRef: NbDialogRef<GetFormMasterFieldsComponent>,
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    const id = this.aRoute.snapshot.params.id;

    
    if(id != null) this.formId = id;
    this.service.getById(this.formId).subscribe((res) => {
      this.fields = res;
      this.finishLoading = true;
    });
    //   this.loadEntities();
  }

  formsfields(id) {
    this.route.navigate(['admin/dynamicForms/formsfields/' + id]);
  }

  addForm() {
    this.diag.open(CreateFormComponent).onClose.subscribe((res) => {
      if (res === 'true') this.ngOnInit();
    });
  }

  active(id) {
    this.service.post({ id: id }, '/Apply').subscribe(
      (res) => {
        this.toast.success('Active form successfully', 'sucess', { duration: 4000 });
      },
      (err) => {
        this.toast.danger('Failed To active form', 'Failed', { duration: 4000 });
      }
    );
  }

  save() {
    this.service.post(this.fields, '/SaveForm').subscribe((res) => {
      this.toast.success('Submit Data Successfully', 'sucess', { duration: 4000 });
      // this.diagRef.close();
    });

    // this.service.post(this.fields, '/GetForm').subscribe((res) => {
    //   this.toast.success('Submit Data Successfully', 'sucess', { duration: 4000 });
    //   this.diagRef.close();
    // });
  }

  uploadFile(files: any, item) {
    const formData = new FormData();
    for (let file of files) {
      formData.append(file.name, file);
    }
    this.service.uploadFile(formData).subscribe((res) => {
      item.submittedValue = res.fileName;
    });
  }
}
